module.exports = __webpack_public_path__ + "media/react-images-upload/UploadIcon-469126df.svg";